import { Controller } from "stimulus";

export default class extends Controller {
 
  static targets = ["retryBtn", "content"];

  connect() {
    const currentUserId = document.body.dataset.userId
    const currentUserRole = document.body.dataset.userRole;
    var minutesFromSentAt = Math.floor((Date.parse(new Date) - Date.parse(this.element.dataset.sentAt)) / 1000 / 60)
   

    if (currentUserRole == "admin" || (currentUserId == this.element.dataset.userId && minutesFromSentAt < 60)) {
      this.element.querySelectorAll(".message-actions").forEach((el) => {
        el.classList.remove("hidden");
      })
    }

    var messagesList = document.getElementById("messagesList")
    var tempMessageID = this.element.dataset.tempId;
    var tempMessage = document.getElementById(tempMessageID);
    if (!!tempMessage) tempMessage.remove();

    if (this.element.classList.contains("new-prepended-message") == false) {
      // leave it
      messagesList.scrollTop = messagesList.scrollHeight;
  
      setTimeout(() => {
        messagesList.scrollTop = messagesList.scrollHeight;
      }, 150);
    } else {
      messagesList.querySelector(".thread-message-wrapper:not(.new-prepended-message)").scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      document.getElementById("messagesList").scrollTop -= 60
      // this.element.classList.remove("new-prepended-message")

      // TODO optimize
      setTimeout(() => {
        document.querySelectorAll(".thread-message-wrapper.new-prepended-message").forEach((el) => {
          el.classList.remove("new-prepended-message");
        });
      }, 500);
    }
    
    



  }


  retrySubmit() {
    var textarea = document.querySelector("textarea#thread_message_message");
    textarea.value = this.contentTarget.textContent;
    textarea.dispatchEvent(new CustomEvent("change"));
    // var submitBtn = textarea.closest("form").querySelector("input[type=submit]");
    // setTimeout(() => {
    //   submitBtn.click();
    // }, 0);
    var tempMessageID = this.element.closest(".temp-message-container").id;
    // this.element.closest(`#${tempMessageID}.temp-message-container`).remove();
    document.getElementById(tempMessageID).remove();
    window.dispatchEvent(new CustomEvent("retry-message-send", {'detail': {tempId: tempMessageID}}));
  }



  replyTo(e) {
    var messageIDToReplyTo = e.target.dataset.messageId;
    var messageContentToReplyTo = e.target.closest(".message-bubble").querySelector(".thread-message-content-inner").innerHTML;
    window.dispatchEvent(new CustomEvent("reply-to-message", {'detail': {messageId: messageIDToReplyTo, messageContent: messageContentToReplyTo}}))
  }


}